import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        mapping: {
          floorImportTemplateFile: string
        }
      }
    }
  }
}

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            mapping: { floorImportTemplateFile },
          },
        },
      },
    }: Payload) => floorImportTemplateFile
  )
}

const query = gql`
  query FloorImportTemplate {
    viewer {
      company {
        mapping {
          floorImportTemplateFile
        }
      }
    }
  }
`
